import { render, staticRenderFns } from "./StepGoMedicus.vue?vue&type=template&id=0dff9e99"
import script from "./StepGoMedicus.vue?vue&type=script&lang=js"
export * from "./StepGoMedicus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports